import React from 'react';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import RediscoveryPageContent from 'talent_matching/talent_rediscovery/rediscovery_page_content';
import { RediscoveryTabContextProvider } from 'talent_matching/contexts/rediscovery_tab_context';
import noop from 'lodash/noop';
import {
  APPLICATION_TYPE,
  TalentRediscoveryFilters,
} from 'talent_search/shared/types';
import { RediscoveryProps } from 'talent_matching/types';
import { useUserContext } from 'talent_matching/contexts/user_context';

const PER_PAGE = 50;

function buildDefaultValues(userDateFormat: string): TalentRediscoveryFilters {
  return {
    milestone: null,
    stages: [],
    rejection_reasons: [],
    exclude_by_rejection_reasons: true,
    scorecard_performance: null,
    no_strong_no_scores: false,
    exclude_hired: false,
    exclude_anonymized: true,
    last_activity_start: null,
    last_activity_end: null,
    can_have: [],
    must_have: [],
    does_not_have: [],
    referrals_only: false,
    internal_only: false,
    candidate_tags: [],
    custom_fields: [],
    schools: [],
    degrees: [],
    disciplines: [],
    application_fields: [],
    full_text: 1,
    jobs: [],
    departments: [],
    offices: [],
    job_status: 'all',
    application_type: APPLICATION_TYPE.CANDIDATE,
    prospect_pools: [],
    prospect_pool_stages: [],
    prospect_owners: [],
    sources: [],
    events: [],
    user_date_format: userDateFormat,
    page: 1,
    perPage: PER_PAGE,
  };
}

const TalentRediscovery = (rediscoveryProps: RediscoveryProps) => {
  const { userDateFormat } = useUserContext();
  const defaultValues = buildDefaultValues(userDateFormat);

  return (
    <RediscoveryTabContextProvider rediscoveryProps={rediscoveryProps}>
      <Form defaultValues={defaultValues} onSubmit={noop} submitMode="preserve">
        <RediscoveryPageContent defaultValues={defaultValues} />
      </Form>
    </RediscoveryTabContextProvider>
  );
};

export default TalentRediscovery;
